"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForEach = void 0;
class ForEach {
    constructor(elementRenderer, separator) {
        this.elementRenderer = elementRenderer;
        this.separator = separator;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    format(elements, parameter) {
        return elements
            .map((element, index) => this.elementRenderer.default(Object.assign(Object.assign(Object.assign({}, parameter), element), { element, index })))
            .join(this.separator);
    }
}
exports.ForEach = ForEach;
//# sourceMappingURL=for_each.js.map